import { EventTracker } from 'Library/eventTacker';
import { Color } from 'Pods/editor/color';
import { Editor } from 'Pods/editor/editor';
import { Shape } from 'Pods/editor/shape';
import { setInitialStrokeWith, strokeWidth } from 'Pods/editor/stroke';
import { resetValues, restore } from 'Pods/editor/transformation';
import { FeatureFlag } from 'Project/ts/library/featureFlag';

export class EditorHistory {
    public index: number;
    public events: HistoryEvent[];
    private undoButton = document.getElementById('_svg_editor_undoBtn') as HTMLButtonElement;
    private redoButton = document.getElementById('_svg_editor_redoBtn') as HTMLButtonElement;
    private resetButton = document.getElementById('_svg_editor_resetBtn') as HTMLButtonElement;
    private debounceTimer: ReturnType<typeof setTimeout>;

    constructor() {
        this.events = [];
        this.index = -1;
        this.checkButtonStatus();
        this.handleListeners();
    }

    public push(event: HistoryEvent) {
        if (typeof this.debounceTimer !== 'undefined') {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            if (this.index != this.events.length - 1) {
                this.events.splice(this.index + 1);
            }
            if (event.type == 'color') {
                Color.handleEventColors();
            }
            this.events.push(event);
            this.index++;
            this.checkButtonStatus();
        }, 300);
    }

    public undo = () => {
        let event: HistoryEvent = this.events[this.index];
        if (event.type == 'color') {
            Color.setSVGColor(event.data.fromColor, event.data.element);
            this.index--;
        } else {
            this.index--;
            if (this.index == -1) {
                event.type == 'strokeWidth' ? setInitialStrokeWith() : restore(true);
            } else {
                event = this.events[this.index];
                event.type == 'strokeWidth' ? strokeWidth(event.data, true, true, true) : restore(event.data);
            }
        }

        this.checkButtonStatus();
        EventTracker.send('ga', 'event', Editor.editorTrackerTag, 'history', 'undo');
    };

    public redo = () => {
        this.index++;
        let event: HistoryEvent = this.events[this.index];

        if (event.type == 'color') {
            Color.setSVGColor(event.data.toColor, event.data.element);
        } else if (event.type == 'strokeWidth') {
            strokeWidth(event.data, true, true, true);
        } else {
            restore(event.data);
        }

        this.checkButtonStatus();
        EventTracker.send('ga', 'event', Editor.editorTrackerTag, 'history', 'redo');
    };

    public reset = () => {
        if (Editor.draw) {
            Editor.draw.find('g')[0].replace(Editor.initial.find('g')[0]);
            Editor.initial = Editor.draw.clone();
            this.events = [];
            this.index = -1;
            this.checkButtonStatus();
            this.handleListeners();
            Color.getColors(Editor.draw);
            Shape.reset();

            setInitialStrokeWith();

            resetValues();
            EventTracker.send('ga', 'event', Editor.editorTrackerTag, 'history', 'reset');
        }
    };

    public checkButtonStatus() {
        let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
        if (this.index == -1) {
            this.undoButton.disabled = true;
            this.resetButton.disabled = true;
            saveIntoButtonElement.disabled = true;
        } else {
            this.undoButton.disabled = false;
            this.resetButton.disabled = false;
            if (document.querySelector('.detail__editor .free_user_warning')?.classList.contains('hidden')) {
                saveIntoButtonElement.disabled = false;
            }
        }
        if (this.index < this.events.length - 1) {
            this.redoButton.disabled = false;
            this.resetButton.disabled = false;
        } else {
            this.redoButton.disabled = true;
        }
    }

    public handleListeners() {
        this.undoButton.onclick = this.undo;
        this.redoButton.onclick = this.redo;
        this.resetButton.onclick = this.reset;
    }
}

export interface HistoryEvent {
    type: string;
    data: any;
}
